export default __webpack_public_path__ + "static/media/Main.7528ce75.png";